import { createFileRoute } from '@tanstack/react-router'
import { AnalyticalWorkflowPage } from '@/components/infoPages/AnalyticalWorkflowPage'
import { withPublicPageSeo } from '@/modules/seo'

const AnalyticalWorkflowPageWithSeo = withPublicPageSeo(
  'solveAnalyticalTask',
  AnalyticalWorkflowPage
)

export const Route = createFileRoute('/$lang/analytical-workflow')({
  component: AnalyticalWorkflowPageWithSeo,
})
